import { lazy } from "react";



const ChangePassword = lazy(
  () => import("../pages/common/change-password/ChangePassword"),
);
// Admin imports
const AdminDashboard = lazy(
  () => import("../pages/admin/dashboard/AdminDashboard"),
);
const AdminOrder = lazy(() => import("../pages/admin/order/AdminOrder"));
const AdminUnreserveRequests = lazy(
  () => import("../pages/admin/unreserve-request/UnReserveRequests"),
);
const AdminInventory = lazy(
  () => import("../pages/admin/inventory/AdminInventory"),
);
const AdminProduction = lazy(
  () => import("../pages/admin/production/AdminProduction"),
);

const AdminOutOfStockItems = lazy(
  () => import("../pages/admin/out-of-stock/OutOfStockItems"),
);

const AdminLowStockItems = lazy(
  () => import("../pages/admin/low-stock/LowStockItems"),
);

const AdminStaffMembers = lazy(
  () => import("../pages/admin/staff-members/StaffMembers"),
);
const AdminProducts = lazy(() => import("../pages/admin/products/Products"));
const Notification = lazy(
  () => import("../pages/common/notification/Notification"),
);
const AdminSettings = lazy(
  () => import("../pages/admin/settings/AdminSettings"),
);
const AdminInsights = lazy(() => import("../pages/admin/insights/Insights"));

const AdminReports = lazy(() => import("../pages/admin/reports/AdminReports"));
const AdminSalesReports = lazy(
  () => import("../pages/admin/reports/sales-report/SalesReport"),
);
const AdminPurchaseReports = lazy(
  () => import("../pages/admin/reports/purchase-report/PurchaseReport"),
);
const AdminInventoryReports = lazy(
  () =>
    import("../pages/admin/reports/inventory-inward-report/InventoryInwardReport"),
);
const AdminDispatchReports = lazy(
  () => import("../pages/admin/reports/dispatch-report/DispatchReport"),
);

// Sales Executive imports
const SalesExecutiveDashboard = lazy(
  () => import("../pages/sales-executive/dashboard/SalesExecutiveDashboard"),
);
const SalesExecutiveOrder = lazy(
  () => import("../pages/sales-executive/orders/SalesExecutiveOrder"),
);
const SalesExecutiveCustomer = lazy(
  () => import("../pages/sales-executive/customers/Customers"),
);
// const SalesExecutiveInventory = lazy(
//   () => import("../pages/sales-executive/inventory/SalesExecutiveInventory"),
// );
const SalesExecutiveProduct = lazy(
  () => import("../pages/sales-executive/products/Products"),
);
const SalesExecutiveSettings = lazy(
  () => import("../pages/sales-executive/settings/SalesExecutiveSettings"),
);


// Purchase Manager imports
const PurchaseManagerDashboard = lazy(
  () => import("../pages/purchase-manager/dashboard/PurchaseManagerDashboard"),
);
const PurchaseManagerOrders = lazy(
  () => import("../pages/purchase-manager/orders/PurchaseManagerOrder"),
);
const PurchaseManagerInventory = lazy(
  () => import("../pages/purchase-manager/inventory/PurchaseManagerInventory"),
);
const PurchaseManagerSettings = lazy(
  () => import("../pages/purchase-manager/settings/PurchaseManagerSettings"),
);

// Warehouse Manager imports
const WareHouseManagerDashboard = lazy(
  () =>
    import("../pages/warehouse-manager/dashboard/WareHouseManagerDashboard"),
);
const WareHouseManagerOrders = lazy(
  () => import("../pages/warehouse-manager/orders/WareHouseManagerOrders"),
);
const WareHouseManagerInventory = lazy(
  () =>
    import("../pages/warehouse-manager/inventory/WareHouseManagerInventory"),
);
const WareHouseManagerSettings = lazy(
  () => import("../pages/warehouse-manager/settings/WareHouseManagerSettings"),
);
const WareHouseManagerOutOfStockItems = lazy(
  () => import("../pages/warehouse-manager/out-of-stock/OutOfStockItems"),
);

const WareHouseManagerLowStockItems = lazy(
  () => import("../pages/warehouse-manager/low-stock/LowStockItems"),
);

const WareHouseManagerRackManagement = lazy(
  () => import("../pages/warehouse-manager/rack-management/RackManagement"),
);

const WareHouseManagerProducts = lazy(
  () => import("../pages/warehouse-manager/products/Products"),
);
export const AdminRoutes = [
  { path: "", element: <AdminDashboard />, title: "Dashboard" },
  { path: "dashboard", element: <AdminDashboard />, title: "Dashboard" },
  {
    path: "unreserve-requests",
    element: <AdminUnreserveRequests />,
    title: "Unreserve Requests",
  },
  { path: "order", element: <AdminOrder />, title: "Order" },
  {
    path: "staff-members",
    element: <AdminStaffMembers />,
    title: "StaffMembers",
  },
  {
    path: "products",
    element: <AdminProducts />,
    title: "Products",
  },
  {
    path: "out-of-stock-products",
    element: <AdminOutOfStockItems />,
    title: "Out Of Stock Products",
  },
  {
    path: "low-stock-items",
    element: <AdminLowStockItems />,
    title: "Low Stock Products",
  },
  { path: "inventory", element: <AdminInventory />, title: "Inventory" },
  { path: "reports", element: <AdminReports />, title: "Reports" },
  {
    path: "reports/inventory-report",
    element: <AdminInventoryReports />,
    title: "InventoryReport",
  },
  {
    path: "reports/sales-report",
    element: <AdminSalesReports />,
    title: "SalesReport",
  },
  {
    path: "reports/purchase-report",
    element: <AdminPurchaseReports />,
    title: "PurchaseReport",
  },
  {
    path: "reports/dispatch-report",
    element: <AdminDispatchReports />,
    title: "DispatchReport",
  },
  { path: "production", element: <AdminProduction />, title: "Production" },
  { path: "notification", element: <Notification />, title: "Notifications" },
  { path: "settings", element: <AdminSettings />, title: "Setting" },
  { path: "insights", element: <AdminInsights />, title: "Insights" },
  { path: "change-password", element: <ChangePassword />, title: "ChangePassword" },
];

export const SalesExecutiveRoutes = [
  { path: "", element: <SalesExecutiveDashboard />, title: "Dashboard" },
  {
    path: "dashboard",
    element: <SalesExecutiveDashboard />,
    title: "Dashboard",
  },
  { path: "order", element: <SalesExecutiveOrder />, title: "Order" },
  { path: "notification", element: <Notification />, title: "Notifications" },
  { path: "customer", element: <SalesExecutiveCustomer />, title: "Customer" },
  { path: "products", element: <SalesExecutiveProduct />, title: "Products" },
  { path: "settings", element: <SalesExecutiveSettings />, title: "Setting" },
  { path: "change-password", element: <ChangePassword />, title: "ChangePassword" },
];

export const PurchaseManagerRoutes = [
  { path: "", element: <PurchaseManagerDashboard />, title: "Dashboard" },
  {
    path: "dashboard",
    element: <PurchaseManagerDashboard />,
    title: "Dashboard",
  },
  { path: "inventory", element: <PurchaseManagerInventory />, title: "Inventory" },
  { path: "notification", element: <Notification />, title: "Notifications" },
  { path: "order", element: <PurchaseManagerOrders />, title: "Order" },
  { path: "settings", element: <PurchaseManagerSettings />, title: "Setting" },
  { path: "change-password", element: <ChangePassword />, title: "ChangePassword" },
];

export const WareHouseManagerRoutes = [
  { path: "", element: <WareHouseManagerDashboard />, title: "Dashboard" },
  {
    path: "dashboard",
    element: <WareHouseManagerDashboard />,
    title: "Dashboard",
  },
  { path: "order", element: <WareHouseManagerOrders />, title: "Order" },
  { path: "notification", element: <Notification />, title: "Notifications" },
  {
    path: "products",
    element: <WareHouseManagerProducts />,
    title: "Products",
  },
  {
    path: "inventory",
    element: <WareHouseManagerInventory />,
    title: "Inventory",
  },
  {
    path: "out-of-stock-products",
    element: <WareHouseManagerOutOfStockItems />,
    title: "Out Of Stock Products",
  },
  {
    path: "low-stock-products",
    element: <WareHouseManagerLowStockItems />,
    title: "Low Stock Products",
  },
  {
    path: "rack-management",
    element: <WareHouseManagerRackManagement />,
    title: "Rack Management",
  },
  { path: "settings", element: <WareHouseManagerSettings />, title: "Setting" },
  { path: "change-password", element: <ChangePassword />, title: "ChangePassword" },
];
